// extracted by mini-css-extract-plugin
export default {"container":"FastStatusBar_container__X4X6b"};